import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { Casino, Style } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import './GameSelection.scss';
import SubscriptionGate from '../components/SubscriptionGate';

export default function GameSelection() {
    const { t } = useTranslation();
    return <main className="app-page game-selection-page">
        <section className="game-selection-content">
            <Typography component="h1" variant="h4">{t('gameSelection.chooseGame')}</Typography>
            <div className="game-selection-grid">
                {[
                    { title: 'gameSelection.poker', description: 'gameSelection.pokerDescription', path: '/poker', icon: <Casino /> },
                    { title: 'gameSelection.shan', description: 'gameSelection.shanDescription', path: '/shan9mee', icon: <Style /> },
                ].map(game => <SubscriptionGate key={game.path} game={game.path === '/poker' ? 'poker' : 'shan9mee'} feature="game"><Card className="game-choice-card">
                    <CardActionArea component={Link} to={game.path}>
                        {game.icon}
                        <CardContent>
                            <Typography component="h2" variant="h5">{t(game.title)}</Typography>
                            <Typography>{t(game.description)}</Typography>
                        </CardContent>
                    </CardActionArea>
                </Card></SubscriptionGate>)}
            </div>
        </section>
    </main>;
}
